import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { global } from '../global';
import { SocialComment } from '../interface/SocialCommentInterface';
import { SseService } from './SseService';

@Injectable({
    providedIn: 'root'
})
export class SocialCommentService {

    public url = global.url;

    constructor(private http: HttpClient, private sseService: SseService) {}

getComments(auth_token: string, network?: string): Observable<SocialComment[]> {

    let endpoint = 'social/comments';

    if (network) {
        endpoint += '?network=' + network;
    }

    return this.sseService.apiGetWithAuth(endpoint, auth_token);
}
    replyToComment(data: any, userId: number) {

        return this.http.post(
            this.url + 'social/comments/reply?userId=' + userId,
            data
        );
    }
    deleteComment(data: { network: string; commentId: string }, userId: number) {
        return this.http.delete(
            `${this.url}social/comments/comment?userId=${userId}`,
            { body: data }
        );
    }
}